<template>
  <span>
    <a target="_blank" :href="url">{{ text }}</a>
    &nbsp;<v-icon x-small>mdi-open-in-new</v-icon>
  </span>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
  },
};
</script>

<style></style>
